import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { UserArea } from '../models/user-area';

@Injectable({
  providedIn: 'root',
})
export class CurrentUserAreasApi {
  private readonly http = inject(HttpClient);
  private readonly endpoint = `${environment.urlApi}api/areas/current-user`;

  getAll(): Observable<UserArea[]> {
    return this.http.get<UserArea[]>(this.endpoint);
  }
}
